var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { margin, compose } from 'styled-system';
import { Space } from '../Space';
var StyledFieldset = styled.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  border: none;\n  ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  border: none;\n  ", ";\n"])), compose(margin));
var StyledLegend = styled.legend(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isSROnly = _a.isSROnly, _b = _a.theme, space = _b.space, font = _b.font, screenReader = _b.screenReader;
    return "\n    ".concat(isSROnly
        ? "\n            ".concat(screenReader.srOnly, "\n            font-size: 0;\n          ")
        : "\n            font-weight: bold;\n            font-size: ".concat(font.body.xs.size, ";\n            margin-bottom: ").concat(space.md, ";\n          "), "\n  ");
});
var CheckboxGroup = function (_a) {
    var name = _a.name, legendText = _a.legendText, children = _a.children, isSROnly = _a.isSROnly, className = _a.className, others = __rest(_a, ["name", "legendText", "children", "isSROnly", "className"]);
    return (React.createElement(StyledFieldset, __assign({ name: name, className: className }, others),
        React.createElement(StyledLegend, { isSROnly: isSROnly }, legendText),
        React.Children.map(children, function (child, i) {
            var isFirst = i === 0;
            if (isFirst)
                return child;
            return React.createElement(Space, { mt: "md" }, child);
        })));
};
export { CheckboxGroup, CheckboxGroup as CheckboxGroupForProps };
var templateObject_1, templateObject_2;
//# sourceMappingURL=CheckboxGroup.js.map